'use strict';

module.exports = {
  productOnly: 'productOnly',
  allUnlocked: 'allUnlocked',
};
